import React from 'react'
import {PageTitle} from '_metronic/layout/core'
import ChatPanel from './components/ChatPanel'

const PAGE_WRAP: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  maxWidth: 960,
  margin: '0 auto',
  padding: '8px 0 24px',
}

const HEADER: React.CSSProperties = {
  background: 'var(--card-bg)',
  border: '1px solid var(--card-border)',
  borderRadius: 14,
  padding: '18px 22px',
}

export default function AiCoachPage() {
  return (
    <>
      <PageTitle description='Your personal trading coach'>AI Coach</PageTitle>
      <div style={PAGE_WRAP}>
        <div style={HEADER}>
          <div style={{fontSize: 18, fontWeight: 600, marginBottom: 6}}>Personal AI Coach</div>
          <div style={{fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5}}>
            Combines your active setups, the last 30 days of R performance, and live market data
            (CoinGlass, Arkham and OKX live price for any coin you mention) to give you personal
            feedback. Answers usually take 8-15 seconds. The AI is a coach — not financial advice.
          </div>
        </div>
        <ChatPanel />
      </div>
    </>
  )
}
